export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
